import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ShoppingCartIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/offer";
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const check = () => {
      const anchor = document.getElementById("first-cta");
      if (!anchor) return;
      setVisible(anchor.getBoundingClientRect().bottom < 0);
    };
    check();
    window.addEventListener("scroll", check, {
      passive: true
    });
    window.addEventListener("resize", check);
    return () => {
      window.removeEventListener("scroll", check);
      window.removeEventListener("resize", check);
    };
  }, []);
  return <AnimatePresence data-id="element-35" data-mp="bq9g8t3kxe1t">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 pt-2 sm:px-6" data-id="element-36" data-mp="195ws7c6utp9f">
          <a href={CHECKOUT_URL} className="animate-shake mx-auto flex max-w-xl items-center justify-center gap-2.5 rounded-2xl border-2 border-ink bg-cta px-4 py-4 font-display text-base font-black uppercase text-ink shadow-[0_10px_30px_-6px_rgba(7,27,51,0.55)] sm:text-lg" data-id="element-37" data-mp="2f3soamxrjygk">
            <ShoppingCartIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-38" data-mp="1rdydsc0x2lzh" />
            <span className="whitespace-nowrap" data-id="element-39" data-mp="1wdjdionwuyd9">Get access now — $27</span>
            <span className="hidden text-sm font-bold text-alert line-through sm:inline" data-id="element-40" data-mp="1wbgbt7debgsp">$180</span>
          </a>
        </motion.div>}
    </AnimatePresence>;
}